import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "bg-merinos-50 border border-merinos-100 rounded-3xl overflow-hidden" }
const _hoisted_2 = { class: "text-merinos-400 uppercase font-black text-sm" }
const _hoisted_3 = { class: "flex items-center gap-x-4" }
const _hoisted_4 = { class: "text-merinos-800 font-medium truncate max-w-[170px] hidden s:block" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "px-4 py-6" }


export default {
  __name: 'Dropdown',
  props: {
  label: String,
  description: String,
  isExpanded: Boolean,
},
  emits: ['open'],
  setup(__props, { emit: __emit }) {



const emit = __emit

return (_ctx, _cache) => {
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { mode: "out-in" }, {
      default: _withCtx(() => [
        (!__props.isExpanded)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = $event => (emit('open'))),
              class: "flex items-center justify-between px-4 py-5"
            }, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(__props.label), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (__props.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.description), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _renderSlot(_ctx.$slots, "description")
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("button", { class: "flex-1" }, [
                  _createElementVNode("svg", {
                    width: "40",
                    height: "40",
                    viewBox: "0 0 40 40",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("circle", {
                      cx: "20",
                      cy: "20",
                      r: "20",
                      fill: "#E5DED2"
                    }),
                    _createElementVNode("mask", {
                      id: "mask0_1531_15314",
                      style: {"mask-type":"alpha"},
                      maskUnits: "userSpaceOnUse",
                      x: "8",
                      y: "8",
                      width: "25",
                      height: "25"
                    }, [
                      _createElementVNode("rect", {
                        x: "8.4292",
                        y: "8.45728",
                        width: "24",
                        height: "24",
                        fill: "#D9D9D9"
                      })
                    ]),
                    _createElementVNode("g", { mask: "url(#mask0_1531_15314)" }, [
                      _createElementVNode("path", {
                        d: "M19.6792 27.2073V21.2073H13.6792V19.7073H19.6792V13.7073H21.1792V19.7073H27.1792V21.2073H21.1792V27.2073H19.6792Z",
                        fill: "#594631"
                      })
                    ])
                  ])
                ], -1 /* HOISTED */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 3 /* FORWARDED */
    }),
    _createVNode(_component_Collapse, {
      when: __props.isExpanded,
      class: "v-collapse"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["when"])
  ]))
}
}

}